import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ChestItem from '@/roc/effects/Production/ChestItem';

const GrandSmithy = {
  id: '77',
  name: "Grand Smithy",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Grand_Smithy',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Grand_Smithy',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        0, 0, 0, 0, 0, 0, 0, 0, 0,
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
        2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
        5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
        6,
      ]),
    ),
    new PassiveAura(
      PassiveAuraType.SIEGE_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        1.00, 1.13, 1.25, 1.38, 1.50, 1.63, 1.75, 1.88, 2.00, 2.00,
        2.25, 2.38, 2.50, 2.63, 2.63, 2.88, 3.00, 3.13, 3.25, 3.25,
        3.50, 3.50, 3.75, 3.88, 4.00, 4.13, 4.25, 4.38, 4.50, 4.50,
        4.75, 4.88, 5.00, 5.13, 5.13, 5.38, 5.50, 5.63, 5.75, 5.75,
        6.00, 6.00, 6.25, 6.38, 6.50, 6.63, 6.75, 6.88, 7.00, 7.00,
        7.25, 7.38, 7.50, 7.63, 7.63, 7.88, 8.00, 8.13, 8.25, 8.25,
      ]),
      '%',
    ),
    new ProductionQueue(
      ProductionWorkforce.asCallbackWithLevel(
        (level) => {
          if (level < 22) {
            return 3;
          }
          if (level < 42) {
            return 4;
          }
          if (level < 55) {
            return 5;
          }
          return 6;
        }
      ),
      [
        ProductionCost.asCallbackWithLevel(
          (level) => {
            if (level < 22) {
              return 50;
            }
            if (level < 42) {
              return 100;
            }
            return 150;
          }
        ).withCurrency(ProductionCurrency.CURRENT_ERA_PRIMARY_GOODS),
      ],
      ProductionDuration.asFlat(8 * 60 * 60),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level < 22) {
            return 1;
          }
          if (level < 42) {
            return 2;
          }
          return 3;
        }
      ).withOutput(ProductionOutputType.RANDOM_BARRACKS_REFILL),
    ),
    new ProductionQueue(
      ProductionWorkforce.asCallbackWithLevel(
        (level) => {
          if (level < 15) {
            return 0;
          }
          if (level < 22) {
            return 3;
          }
          if (level < 42) {
            return 4;
          }
          if (level < 55) {
            return 5;
          }
          return 6;
        }
      ),
      [
        ProductionCost.asCallbackWithLevel(
          (level) => {
            if (level <= 22) {
              return 50;
            }
            if (level < 42) {
              return 100;
            }
            return 150;
          }
        ).withCurrency(ProductionCurrency.CURRENT_ERA_PRIMARY_GOODS),
      ],
      ProductionDuration.asFlat(12 * 60 * 60),
      ProductionOutput.asCallbackWithLevel(
        (level) => level < 15 ? 0 : 1
      ).withOutput(ProductionOutputType.CHEST).withItems([
        ChestItem.asCallbackWithLevel(
          (level) => {
            if (level < 15) {
              return 0;
            }
            if (level < 22) {
              return 1;
            }
            if (level < 42) {
              return 2;
            }
            return 3;
          }
        ).withOutput(ProductionOutputType.RANDOM_BARRACKS_REFILL),
        ChestItem.asCallbackWithLevel(
          (level) => {
            if (level < 15) {
              return 0;
            }
            if (level < 22) {
              return 1;
            }
            if (level < 42) {
              return 2;
            }
            return 3;
          }
        ).withOutput(ProductionOutputType.RANDOM_MERCENARY_COMMANDER),
      ]),
    ),
  ]),
};

export default GrandSmithy;
